// noinspection GraphQLUnresolvedReference

import { gql } from "graphql-request";

export const GetOverallResult = gql`
    mutation ExecuteGetScenarioResult(
        $inScenarioID: UUID!
        $inState: String,
        $inInfraFlag: String,
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int
        $inLocationID: String
    ) {
        executeGetScenarioResult(
            inScenarioID: $inScenarioID
            inState: $inState
            inInfraFlag: $inInfraFlag
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inLocationID: $inLocationID
        ) {
            Month
            Sum_Value
            Sum_Unit
            Scenario_Value
            Scenario_Unit
        }
    }
`;

export const GetDetailedResult = gql`
    mutation ExecuteGetScenarioDetailResult(
        $inScenarioID: UUID!
        $inState: String,
        $inInfraFlag: String,
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int,
        $inDateStart: DateTime,
        $inDateEnd: DateTime
        $inLocationID: String
    ) {
        executeGetScenarioDetailResult(
            inScenarioID: $inScenarioID
            inState: $inState
            inInfraFlag: $inInfraFlag
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inDateStart: $inDateStart
            inDateEnd: $inDateEnd
            inLocationID: $inLocationID
        ) {
            Year
            Quarter
            QuarterYear
            Project1
            Project2
            Project3
            Project4
            Project5
            Project6
            Project7
            Project8
            Project9
            Project10
            Project11
            Project12
            Project13
            Project14
            Project15
            Project16
            Project17
            Project18
            Project19
            Project20
            RemainingProjects
            Baseline
        }
    }
`;

export const GetDetailedProjectResult = gql`
    mutation ExecuteGetScenarioProjectDetailResult(
        $inScenarioID: UUID!
        $inMonth: DateTime,
        $inState: String,
        $inInfraFlag: String,
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int,
        $inLocationID: String
    ) {
        executeGetScenarioProjectDetailResult(
            inScenarioID: $inScenarioID
            inMonth: $inMonth
            inState: $inState
            inInfraFlag: $inInfraFlag
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inLocationID: $inLocationID
        ) {
            Month
            ProjectName
            Source
            InfraFlag
            State
            LocationName
            Investment
            SuperSector
            MasterType
            RawProjectType
            StartDateConstruction
            EndDateConstruction
            StartDatePlanning
            EndDatePlanning
            StartDateCommissioning
            EndDateCommissioning
            PhaseType
            PLEMGroup
            Lvl1Group
            ResourceGroup
            Sum_Value
            Sum_Unit
            Unit
        }
    }
`;

//PollScenarioModelProgress - inScenarioID: String!
export const PollScenarioModelProgress = gql`
    mutation ExecutePollScenarioModelProgress(
        $inScenarioID: UUID!
    ) {
        executePollScenarioModelProgress(
            inScenarioID: $inScenarioID
        ) {
            ScenarioID
            IsProcessing
            ScenarioModelRunStatus
        }
    }
`;
